import React from 'react';
import DialogWithPhoto from '@components/Popups/DialogWithPhoto';
import { FEMALE_USER_RANK } from '@constants/constant';
import StartPoint300 from '@assets/BachelorPoint/Header/start_point_300.png';
import StartPoint500 from '@assets/BachelorPoint/Header/start_point_500.png';

const StartBachelorPointPopUp = ({
  isVisible,
  userCurrentRank,
  onPositiveClicked
}) => {
  let titleImage = StartPoint300;
  if (
    userCurrentRank === FEMALE_USER_RANK.GOLD ||
    userCurrentRank === FEMALE_USER_RANK.SILVER
  ) {
    titleImage = StartPoint300;
  } else if (
    userCurrentRank === FEMALE_USER_RANK.DIAMOND ||
    userCurrentRank === FEMALE_USER_RANK.BLACK
  ) {
    titleImage = StartPoint500;
  }

  return (
    <DialogWithPhoto
      visible={isVisible}
      titleText={'【招待された方限定】\nバチェラーポイントへ特別ご招待！'}
      titleImage={titleImage}
      MessagesComponent={
        <div
          style={{
            fontSize: '15px',
            color: '#242728',
            marginTop: '15px'
          }}
        >
          <div style={{ fontWeight: 'bold' }}>
            デートするほどポイントが貯まる
          </div>
          <div>“バチェラーポイント”が待望のリリース！</div>
          <div>
            貯まったポイントは
            <span style={{ fontWeight: 'bold' }}>Amazonギフト券</span>に
          </div>
          <div>交換可能！</div>
        </div>
      }
      positiveButtonTitle={'詳細を確認する'}
      onPositiveClicked={onPositiveClicked}
    />
  );
};

export default StartBachelorPointPopUp;
